module.exports = __webpack_public_path__ + "static/media/minusCircle.c849025f.svg";